(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = initAdmin

var createController = require('./controllers/controller')

function initAdmin () {
  return { bookingAdmin: init }
}

function init (serviceLocator, done) {

  createController(serviceLocator)
  done()
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/booking/init.js","/components/admin/booking")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vYm9va2luZy9pbml0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cyA9IGluaXRBZG1pblxuXG52YXIgY3JlYXRlQ29udHJvbGxlciA9IHJlcXVpcmUoJy4vY29udHJvbGxlcnMvY29udHJvbGxlcicpXG5cbmZ1bmN0aW9uIGluaXRBZG1pbiAoKSB7XG4gIHJldHVybiB7IGJvb2tpbmdBZG1pbjogaW5pdCB9XG59XG5cbmZ1bmN0aW9uIGluaXQgKHNlcnZpY2VMb2NhdG9yLCBkb25lKSB7XG5cbiAgY3JlYXRlQ29udHJvbGxlcihzZXJ2aWNlTG9jYXRvcilcbiAgZG9uZSgpXG59XG4iXX0=